export default "__VITE_ASSET__CByq7N$x__"